/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import connectionState from './connection-state';


export default combineReducers({
    connectionState,
});
